import * as React from 'react';
import { Col, Row, Input, Divider, Select } from 'antd';

import Form, { FormItem } from '../../../components/Form';
import { Title } from '../../../components/Layout/components';
import LanguageSelect from '../../../components/Others/LanguageSelect';
import CurrencySelect from '../../../components/Others/CurrencySelect';
import BusinessSelect from '../../../components/Others/BusinessSelect';
import CountryStates from './components/CountryStates';

interface ICountryDetailProps {
  domain: string;
  country: GQL.ICountry;
  languages: Array<GQL.ILanguage>;
  onSave: (country: GQL.ICountry) => void;
  onCancel: () => void;
}

interface ICountryDetailState {
  country: GQL.ICountry;
}

export default class CountryDetail extends React.Component<ICountryDetailProps, ICountryDetailState> {

  public constructor(props: ICountryDetailProps) {
    super(props);

    this.state = {
      country: props.country || {},
    };

    if (this.state.country && this.state.country.business) {
      (this.state.country as any).businessId = this.state.country.business.id;
    }

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { country } = this.state;

    return (
      <div>
        <Title>
          {country
            ? `Country ${country.name ? `"${country.name}"` : ''}`
            : `Country`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <Row>
            <Col sm={12}>
              <FormItem label="Name" required={true}>
                <Input
                  autoFocus={true}
                  name={'name'}
                  placeholder="Country name"
                  value={country.name}
                  required={true}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label="Country code">
                <Input
                  name={'code'}
                  placeholder="Country code (to URL)"
                  value={country.code || ''}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label="VAT rate">
                <Input
                  name={'VATrate'}
                  type={'number'}
                  addonAfter={'%'}
                  placeholder="VAT rate in country"
                  value={country.VATrate || ''}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label="Weight unit" required={true}>
                <Select
                  value={country.weightUnit}
                  showSearch={false}
                  placeholder={'Weight unit'}
                  style={{ width: '100%' }}
                  onChange={e => this.onChange({ target: { name: 'weightUnit', value: e } })}
                >
                  <Select.Option value={'kg'}>kg</Select.Option>
                  <Select.Option value={'lb'}>lb</Select.Option>
                </Select>
              </FormItem>
              <FormItem label="Business">
                <BusinessSelect
                  name={'businessId'}
                  value={country && (country as any).businessId ? (country as any).businessId : undefined}
                  onChange={(e: any) => this.onChange(e)}
                />
              </FormItem>
              <FormItem label="Language">
                <LanguageSelect
                  name={'languageId'}
                  value={country && country.languageId ? country.languageId : undefined}
                  onChange={(e: any) => this.onChange(e)}
                />
              </FormItem>
              <FormItem label="Currency">
                <CurrencySelect
                  name={'currencyId'}
                  value={country && country.currencyId ? country.currencyId : undefined}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label="Extra bank name">
                <Input
                  name={'bankName'}
                  placeholder="Bank name for country"
                  value={country.bankName || ''}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label="Extra bank account number">
                <Input
                  name={'bankAccountNumber'}
                  placeholder="Bank account number for country"
                  value={country.bankAccountNumber || ''}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label="Extra IBAN">
                <Input
                  name={'iban'}
                  placeholder="IBAN for country"
                  value={country.iban || ''}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label="Extra Swift">
                <Input
                  name={'swift'}
                  placeholder="Swift for country"
                  value={country.swift || ''}
                  onChange={this.onChange}
                />
              </FormItem>
            </Col>
            <Col sm={1} />
            <Col sm={11}>
              <CountryStates 
                country={country}
                onChange={this.onChange}
              />
            </Col>
          </Row>

        </Form>
      </div>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);
    const newValue = (language
      ? { [name]: { ...this.state.country[name], [language]: inputValue } }
      : { [name]: value });

    this.setState({
      country: { ...this.state.country, ...newValue }
    });
  }

  private async save() {
    this.props.onSave({...this.state.country});
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Countries/CountryDetail/CountryDetail.tsx